module.exports = __webpack_public_path__ + "static/quirksmode-e0c3fd544294544b803a97fdfb660d4a.png";